import { PostMessageErrorIcon, SocketIcon } from "../../assets/icons";
import { Card } from "../Card";
import { Text } from "../Text";
import classes from "./ErrorCard.module.css";
import { ErrorCardProps } from "./ErrorCard.types";

export const ErrorCard = (props: ErrorCardProps) => {
  return (
    <Card className={classes.root}>
      {!props.errorCode && !props.failedPostMessageResponse && (
        <>
          <SocketIcon id="error-socket-id" className={classes["socketIcon"]} />
          <p className={classes["align-center"]}>
            <Text
              text="The page did not load"
              fontWeight="semibold"
              variant="heading"
              size="md"
            />
          </p>
          <p className={classes["align-center"]}>
            <Text
              text="Don’t worry. Raise your hand and a staff member will help you."
              variant="body"
              size="md"
            />
          </p>
        </>
      )}

      {props.failedPostMessageResponse && props.errorCode && (
        <>
          <p className={classes.topRight}>
            <Text
              text={props?.errorCode}
              fontWeight="medium"
              size="sm"
            />
          </p>
          <div className={classes.postMessageErrorIcon}>
            <PostMessageErrorIcon id="error-post-message-id" />
          </div>
          <p className={classes["align-center"]}>
            <Text
              text="The page did not load"
              fontWeight="semibold"
              variant="heading"
              size="md"
            />
          </p>
          <p className={classes["align-center"]}>
            <Text
              text="Don’t worry. Your recording is saved."
              variant="body"
              size="sm"
            />
          </p>
          <p className={classes["align-center"]}>
            <Text
              text="Raise your hand and a staff member will help you."
              variant="body"
              size="sm"
            />
          </p>
        </>
      )}

      {!props.failedPostMessageResponse && props.errorCode && (
        <>
          <p className={classes.topRight}>
            <Text
              text={props?.errorCode}
              fontWeight="medium"
              size="sm"
            />
          </p>
          <SocketIcon id="error-socket-id" className={classes["socketIcon"]} />
          <p className={classes["align-center"]}>
            <Text
              text="The page did not load"
              fontWeight="semibold"
              variant="heading"
              size="md"
            />
          </p>
          <p className={classes["align-center"]}>
            <Text
              text="Don’t worry. Raise your hand and a staff member will help you."
              variant="body"
              size="md"
            />
          </p>
        </>
      )}

      {!props.failedPostMessageResponse && props.errorCode === 'recordings are uploaded' && (
        <>
          <p className={classes.topRight}>
            <Text
              text={'V304'}
              fontWeight="medium"
              size="sm"
            />
          </p>
          <SocketIcon id="error-socket-id" className={classes["socketIcon"]} />
          <p className={classes["align-center"]}>
            <Text
              text="The page did not load"
              fontWeight="semibold"
              variant="heading"
              size="md"
            />
          </p>
          <p className={classes["align-center"]}>
            <Text
              text="Don’t worry. Your recording is saved."
              variant="body"
              size="sm"
            />
          </p>
          <p className={classes["align-center"]}>
            <Text
              text="Raise your hand and a staff member will help you."
              variant="body"
              size="sm"
            />
          </p>
        </>
      )}
    </Card>
  );
};
